import StatisticDashboard from '@/pages/statistics/StatisticDashboard';

const PayoutsOutStatistics = () => <StatisticDashboard type="payouts" />;

export default PayoutsOutStatistics;
